<template>
<div>
  <el-row type="flex" justify="end" class="title-bar">
    <w-header-search-button @click="showSearchTool = !showSearchTool" />
  </el-row>
  <el-table-wrapper :data="tableData" :columns="columns" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool" :show-overflow-tooltip="true" :pagination="true" />
</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import { columnDefault } from '@/constants/table';
import TransactionAPI from '@/api/apm/transaction';
import { GX_ID_STRING, OBJ_HASH } from '@/constants/apm-domain-define';

export default {
  name: 'WJsErrorTable',
  props: {
    activeTab: String, // JS Error 탭 이름
    gxid: String,
    params: Object,
  },
  data() {
    return {
      columnDefault,
      showSearchTool: false,
      tableData: [],
      columns: [
        { prop: 'uriText', label: 'URI', searchable: true, sortable: true },
        { prop: 'hostText', label: 'HOST', searchable: true, sortable: true },
        { prop: 'nameText', label: '이름', searchable: true, sortable: true },
        { prop: 'fileText', label: '파일', searchable: true, sortable: true },
        { prop: 'messageText', label: '메시지', searchable: true, sortable: true },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    /**
     * JS Error 탭일 경우 데이터를 로딩한다.
     * @param  {[type]} tabName [description]
     * @return {[type]}         [description]
     * @author jda
     */
    activeTab() {
      this.loadData();
    },
    params() {
      this.loadData();
    },
  },
  methods: {
    /**
     * 스크립트 에러 리스트 조회
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      if (this.activeTab !== 'eumJsError' || isEmpty(this.params)) {
        return;
      }
      const requestParam = {};
      requestParam[GX_ID_STRING] = this.params;
      requestParam[OBJ_HASH] = this.selectedNode.objHash;
      TransactionAPI.getDetailEumJsErrorList(requestParam).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
        } else {
          this.reset();
        }
      });
    },
    /**
     * 테이블 리셋
     * @author jda
     */
    reset() {
      this.tableData = [];
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/apm/transaction-matrix/components/table/JsErrorTable.vue